module.exports = "<div style=\"background-color: whitesmoke; margin: 0; padding: 0; width: 100%;\" >\n  <router-outlet>\n  </router-outlet>\n</div>\n"